import { useState } from 'react';
import { api } from '@/lib/api/core';
import { logError } from '@/lib/logger';
import { trackCtaClick } from '@/lib/analytics';
import { useBfcacheRestore } from '@/hooks/useBfcacheRestore';

export function useGitHubLogin() {
  const [isLoading, setIsLoading] = useState(false);

  // Un-stick the OAuth CTA when the user navigates Back from GitHub - the
  // page is restored from bfcache with isLoading frozen true, leaving every
  // consumer's button disabled forever.
  useBfcacheRestore(() => setIsLoading(false));

  /**
   * @param source Identifier for which CTA triggered login (e.g. 'trust_hero',
   * 'sticky_bar'), recorded as a `cta_click` event for funnel analysis.
   */
  const handleGitHubLogin = async (source?: string) => {
    trackCtaClick({ location: source ?? 'unknown' });
    setIsLoading(true);
    try {
      const { authorization_url } = await api.getGitHubAuthUrl();
      window.location.href = authorization_url;
    } catch (error) {
      logError('Failed to get GitHub auth URL:', error);
      setIsLoading(false);
    }
  };

  return { isLoading, handleGitHubLogin };
}
